<template lang="pug">
.main
  MainMenu(style="position: fixed; z-index: 2;", v-if="showMenus")
  .fill(style="position: fixed; z-index: 1;")
    template(v-if="Store.config.frame.mode == 'SINGLE'")
      Frame(
        :frame="Store.currentFrame",
        :key="Id(Store.currentFrame)",
        :viewUpdateDelay="200"
      )
    template(v-else)
      FrameWindow(
        v-for="frame in Store.frames",
        :key="Id(frame)",
        :frame="frame"
      )
    ModuleOutlet(type="window", v-if="showWindows")
  .jupyter-camera(v-if="Store.jupyterFrame")
    Frame(:frame="Store.jupyterFrame", key="jupyter")
</template>


<script lang="ts">
import Vue from 'vue'
import MainMenu from './MainMenu/index.vue'
import Frame from './Frame/index.vue'
import FrameWindow from './FrameWindow/index.vue'
import { keyboard } from "./keyboard";
import { queryParams } from '../../utils/query_params';

export default Vue.extend({
  components: { MainMenu, Frame, FrameWindow },
  mounted() { keyboard.set() },
  computed: {
    showMenus() {
      return true
      // return !queryParams.inline
    },
    showWindows() {
      return !queryParams.inline
    },
  },
})
</script>


<style lang="scss" scoped>
.fill {
  width: 100%;
  height: 100%;
}

.jupyter-camera {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 64px;
  height: 64px;
  border: solid 1px red;
  z-index: 999;
  visibility: hidden;
}
</style>